const ACTION_COLOR_DEFAULT = "#116DFF";
const TEXT_COLOR_DEFAULT = "#000000";
const BG_COLOR_DEFAULT = "#ffffff";
const FALLBACK_COLOR_DEFAULT = "#000000";
const FALLBACK_COLOR_BRIGHT_DEFAULT = "#FFFFFF";
const HEADING_FONT_SIZES = {
  h1: "40px",
  h2: "28px",
  h3: "24px",
  h4: "20px",
  h5: "18px",
  h6: "16px"
};
const PARAGRAPH_FONT_SIZE = "16px";
export {
  ACTION_COLOR_DEFAULT,
  BG_COLOR_DEFAULT,
  FALLBACK_COLOR_BRIGHT_DEFAULT,
  FALLBACK_COLOR_DEFAULT,
  HEADING_FONT_SIZES,
  PARAGRAPH_FONT_SIZE,
  TEXT_COLOR_DEFAULT
};
//# sourceMappingURL=theme-constants.js.map
